// extracted by mini-css-extract-plugin
export default {"contentParticipants":"contentParticipants__3K6q_","participantsdescription":"participantsdescription__1xrMP","participantsButtonContainer":"participantsButtonContainer__3dgCi","participantsButton":"participantsButton__1uPBd"};
    if(module.hot) {
      // 1745482177208
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  